export const APPLICANT_DATA = 'APPLICANT_DATA';

export const updateApplicantData = (data) => ({ type: APPLICANT_DATA, payload: data });
